import { AutoNation } from "Types/api/Tracking";

const getPageType = (): string | null => {
    const shiftType = (window as any).DIDataLayer?.vars?.page?.shift_type;
    return shiftType === "Vehicle Listing" ? "SRP" : shiftType === "Vehicle Details" ? "VDP" : null;
};

const getAutoNationWtk = (): string | undefined => {
    return (window as any).utag?.data?.wtk_clean;
};

const getAutoNationAid = (): string | undefined => {
    return (window as any).utag?.data?.aid;
};

const getTrackingAutoNation = (): AutoNation | undefined => {
    const wtkTag = getAutoNationWtk();
    const aidTag = getAutoNationAid();

    if (wtkTag === undefined && aidTag === undefined) {
        return undefined;
    }

    return {
        wtk: wtkTag,
        aid: aidTag,
    };
};

export { getTrackingAutoNation, getPageType };
